import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const host = window.location.hostname;
const urlApi = host.includes("localhost")
  ? process.env.VUE_APP_URL_DEV
  : host.includes("qa")
  ? process.env.VUE_APP_URL_QA
  : process.env.VUE_APP_URL_PRD;

const secondsToDate = seconds => new Date(seconds * 1000);

const validateCurrentDateAgainst = date => new Date() > date;

const ValidateToken = access_token => {
  if (!access_token) return;

  try {
    const token = access_token.toString().replace(/['"]+/g, "");
    const payload = token.split(".")[1];
    if (!payload) return;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = JSON.parse(atob(base64));

    const { exp, infoUser } = decoded;
    if (!exp || !infoUser) return;
    const user = JSON.parse(infoUser);

    const expires = secondsToDate(exp);
    if (validateCurrentDateAgainst(expires)) return;

    return { token, user };
  } catch {
    return;
  }
};

const getStoredSession = () => {
  const token = localStorage.getItem("user-token");
  const username = localStorage.getItem("user-name");

  if (!token || !username) return null;

  return { token, user: { username } };
};

const allowByToken = (to, from, next) => {
  const passport = to.query.passport;

  if (passport) {
    const session = ValidateToken(passport);

    if (!session?.token) {
      window.location.replace(urlApi);
      return;
    }

    localStorage.setItem("user-token", session.token);
    localStorage.setItem("user-name", session.user.username);

    next({
      path: to.path,
      replace: true
    });
    return;
  }

  const storedSession = getStoredSession();

  if (storedSession) {
    next();
    return;
  }

  // 🔹 NO HAY SESIÓN
  window.location.replace(urlApi);
};

const routes = [
  {
    path: "/",
    redirect: "/visor"
  },
  {
    path: "/visor",
    name: "visor",
    beforeEnter: allowByToken,
    component: () => import("../views/ApiWeb.vue")
  },
  {
    path: "*",
    redirect: "/visor"
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
